export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-thumbnail-960-72c7b9f2a495a08a3f86b88e4b1ba0f0.png";